import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ParentComponentApi} from '../profile/profile.component';
import {DxFormComponent,DxDateBoxModule} from 'devextreme-angular';
import { Router, ActivatedRoute } from '@angular/router'; 
import { Configuration } from '../../../app.constants';
import {HelperService} from '../../../shared/services/helper.service';
import { compilePipeFromMetadata } from '@angular/compiler';  
import {GrievancessubmissionService, GrievancessubmissionDetails,GrievancesTypeDetails} from '../../services/grievancessubmission.service';
import { ImageUploadService } from '../../../shared/services/image-upload.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpHeaders, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

 
@Component({
  selector: 'app-grievancessubmission',
  templateUrl: './grievancessubmission.component.html',
  styleUrls: ['./grievancessubmission.component.scss']
})
export class GrievancessubmissionComponent implements OnInit {
  @ViewChild(DxFormComponent) GrievancessubmissionForm: DxFormComponent; 
  @Input() GrievancessubmissionData: any=[];  
 
  value: any[] = [];
  urlDoc: string;
  popupVisible: boolean;
  popupTitle: string;

  showButtons:boolean=false;
  loadIndicatorVisible:boolean=false;
  readOnly: boolean = false;
  documentId: string;
  
  isValid: boolean; 
  SaveBtnDisabled: boolean;
  DeleteBtnDisabled :boolean; 
  errorMessage: string[] = new Array(); 
  dataSource:any;  
 
  DocumentsList:any;
  GrievancesTypeList:any;
  BasicLevelList:any
  LanguageLabel:any;
  PreStudentPhyInfoID:0;
  namePattern: any = /^[^0-9]+$/;
  Pattern1: any =/^[^<>]+$/;
  maxYear=0;
  BirthYear=0;
  RequesterID=0; 
  GrievanceDocumentExists:boolean=false;
  GrievanceDocumentPath="";

  selectedFiles: FileList;
  currentFile: File;

  constructor(private http:HttpClient,
    private router: Router,private route: ActivatedRoute, 
    private GrievancessubmissionService:GrievancessubmissionService, 
    private configuration: Configuration,private helperService:HelperService ) { 
      this.maxYear = (new Date()).getFullYear();
    }


  ngOnInit() { 
    this.LanguageLabel =this.configuration.LanguageLabel[0];
    debugger
    if(this.configuration.IsParrent == true){
      this.RequesterID=3;
    }
    else{
      this.RequesterID=1;
    }
    this.clearForm(); 
  }
  getGrievancesTypeDetails(){  
    this.GrievancesTypeList=[]; 
        this.GrievancessubmissionService.GetBasicGrievancesById(0) 
        .subscribe((data: GrievancesTypeDetails[]) => this.dataSource = data,
        err => {
          var error = this.helperService.getErrorMessage(err)
          alert("error");
          },
          () => { debugger      
            if(this.dataSource.length>0){
              this.GrievancesTypeList=this.dataSource; 
            } 
          });  

  }
  
  getStuentGrievancesTypeDetails() {      
    this.DocumentsList=[];
      this.GrievancessubmissionService.GetGrievanceRequestByStudentID(this.configuration.StudentID,this.RequesterID,this.configuration.AcademicInstanceID) 
    .subscribe((data: GrievancessubmissionDetails[]) => this.dataSource = data,
    err => {
      var error = this.helperService.getErrorMessage(err)
      alert("error");
      },
      () => { debugger
        if(this.dataSource.length>0){ 
          this.DocumentsList=this.dataSource; 
        } 
      });  

     /*  this.DocumentsList=[
        {"GrievanceRequestID":1,"Date":"01/Dec/2020","GrievancesType":"Grievances A" ,"GrievanceTypeID":"1","Description":"Student Grievances One"},
        {"GrievanceRequestID":2,"Date":"25/Jan/2021","GrievancesType":"Grievances B" ,"GrievanceTypeID":"2","Description":"Student Grievances Two"},
        {"GrievanceRequestID":3,"Date":"01/Mar/2021","GrievancesType":"Grievances C" ,"GrievanceTypeID":"3","Description":"Student Grievances Three"}
      ]
 */

      /* return this.http.get('../assets/data/grievancessubmissiondata.json')
      .toPromise()
      .then(data => {
        debugger
        this.DocumentsList = data[1];
      }); */

  }
 
  saveRecord() {debugger
    this.SaveBtnDisabled = true;
    if ((this.configuration.StudentID==null)||(this.configuration.StudentID==0))
    {
      this.helperService.showWarningMessage("Blank Student Id Not Allowed.");
      this.SaveBtnDisabled = false;
      return false;    
    }
    if (this.GrievancessubmissionData.GrievanceTypeID == null || this.GrievancessubmissionData.GrievanceTypeID == 0 || this.GrievancessubmissionData.GrievanceTypeID == undefined) {
      this.helperService.showWarningMessage("Select Grievances Type.")
      this.SaveBtnDisabled = false;
      return false;
    } 
    if (this.GrievancessubmissionData.GrievanceDate == null || this.GrievancessubmissionData.GrievanceDate == undefined) {
      this.helperService.showWarningMessage("Select Date.")
      this.SaveBtnDisabled = false;
      return false;
    }
    this.SaveBtnDisabled = true;
    
    if (this.GrievancessubmissionData.GrievanceRequestID == null || this.GrievancessubmissionData.GrievanceRequestID == 0 || this.GrievancessubmissionData.GrievanceRequestID == undefined) {
      this.GrievancessubmissionData.GrievanceRequestID = 0;
    }
    this.GrievancessubmissionData.StudentID=this.configuration.StudentID;
    this.GrievancessubmissionData.CreatedLoginID = this.configuration.CreatedLoginID;
    this.GrievancessubmissionData.UpdatedLoginID = this.configuration.UpdatedLoginID;
    this.GrievancessubmissionData.AcademicInstanceID = this.configuration.AcademicInstanceID;
    this.GrievancessubmissionData.ExamInstanceID = this.configuration.ExamInstanceID;
     
    this.isValid = this.GrievancessubmissionForm.instance.validate().isValid;
    if(this.isValid == true) {  
      this.errorMessage=[];
      debugger; 
      if(this.configuration.IsParrent == true){
        this.GrievancessubmissionData.RequesterID=3;
      }
      else{
        this.GrievancessubmissionData.RequesterID=1;
      }
      if(this.GrievancessubmissionData.GrievanceRequestID > 0 ){ 
        debugger; 
        this.GrievancessubmissionService.PostPreStudentGrievances(this.GrievancessubmissionData)
         .subscribe(value => {  
          },
          err => {
            this.SaveBtnDisabled = false;
            this.errorMessage=this.helperService.getErrorMessage(err);
            this.helperService.showWarningMessage("Not Saved.");  
          },
          () => {
            this.onSuccessSave();   
          });  
      }
      else{
      this.GrievancessubmissionService.PostInsertPreStudentGrievances(this.GrievancessubmissionData)
         .subscribe(value => {   
           this.GrievancessubmissionData.GrievanceRequestID = value; 
         },
           err => {
            this.SaveBtnDisabled = false;     
            this.errorMessage=this.helperService.getErrorMessage(err);
            this.helperService.showWarningMessage("Not Saved."); 
           },
           () => {    
            this.onSuccessSave();       
           });  
      }
    }
  }
  uploadFile(){debugger
    if(this.GrievancessubmissionData.GrievanceRequestID > 0){ 
        /* if(this.configuration.UploadFile != undefined && this.configuration.UploadFile != null && this.configuration.UploadFile != ""){
        this.GrievancessubmissionService.uploadFile(this.configuration.UploadFile, this.configuration.StudentID, this.GrievancessubmissionData.GrievanceRequestID,this.GrievancessubmissionData.RequesterID).subscribe(
          data => { 
          },
          err => {debugger;  
            this.configuration.UploadFile ="";
            this.SaveBtnDisabled = false;    
            this.clearForm() ;
          },
          () => { 
            this.configuration.UploadFile ="";
            this.clearForm() ;
          })  
        }   */



        if(this.currentFile != undefined && this.currentFile != null  ){ 
        let formData = new FormData();
        debugger;
    
         let extention=this.currentFile.name.substring(this.currentFile.name.lastIndexOf(".")+1);
    
         //if(extention != "xlsx" && extention != "xls" )
        if(extention != "pdf" )
        {
          alert("Select Excel File Only!");
          return;
        }
    
        formData.append('file', this.currentFile , this.currentFile.name); 
        formData.append('GrievanceRequestID', this.GrievancessubmissionData.GrievanceRequestID.toString());
        formData.append('StudentID', this.configuration.StudentID.toString());
        formData.append('RequesterID', this.RequesterID.toString());  
    
        //this.AuthService.AddFileDetails(formData).subscribe(result => {});    
       let headers = new HttpHeaders();  
          headers.append('Content-Type', 'form-data');
          headers.append('Accept', 'application/json'); 
          //headers.append('Authorization', 'Bearer ' + sessionStorage.getItem('auth_token'));       
          const httpOptions = {  
              headers: headers  
          };  
          //return this.http.post<any>(this.Configuration.server + this.ApiList[0].SaveApi+"?UpdatedLoginID="+this.Configuration.UpdatedLoginID +"&BatchDate="+this.SubjectForm.value.batchDate +"&InstanceID="+ this.InstanceID +"&SubjectID="+ this.SubjectID, formData, httpOptions);  
          this.http.post<any>(this.configuration.serverWithApiUrl +"/GrievanceRequest/UploadGrievanceSubmissionFile?StudentID=" + this.configuration.StudentID + "&GrievanceRequestID="+ this.GrievancessubmissionData.GrievanceRequestID + "&RequesterID="+ this.RequesterID +"" , formData,{reportProgress: false,observe: 'events'} )
            .subscribe(data => {debugger
              //console.log(data);
             // this.msg="Uploaded Successfully";
              //this.router.navigate(['/adminportal/answersheetdataimportlist']);
        },
        err=>{debugger 
        });  
      }    
      this.clearForm() ; 
    }
    else{ 
      this.clearForm() ;
    } 
  }
  cancelClick(){
    this.SaveBtnDisabled = false;    
    this.DeleteBtnDisabled = false;
    this.errorMessage=[];
    this.router.navigate(['/login-form']);
  }

  onSuccessSave() {         
    this.getStuentGrievancesTypeDetails();
    this.helperService.showSuccessMessage("Saved Successfully.");   
    this.uploadFile();
  }

  clearForm() {   
    this.GrievancessubmissionData ={};
    this.GrievancessubmissionData.GrievanceRequestID   = 0;
    this.GrievancessubmissionData.StudentID            =this.configuration.StudentID;
    this.GrievancessubmissionData.AcademicInstanceID   = 0;
    this.GrievancessubmissionData.ExamInstanceID       = 0;
    this.GrievancessubmissionData.GrievanceTypeID      = 0; 
    this.GrievancessubmissionData.Description       =null;
    this.GrievancessubmissionData.GrievanceDocument       ="";
    this.GrievancessubmissionData.GrievanceDocumentPath       ="";
     this.DeleteBtnDisabled = true;
     this.SaveBtnDisabled = false;
     this.getGrievancesTypeDetails();
     this.getStuentGrievancesTypeDetails();
  }
  
  deleteRecord() {
    debugger
    if(this.GrievancessubmissionData.GrievanceRequestID > 0){
      this.DeleteBtnDisabled = false;
      this.GrievancessubmissionData.StudentID=this.configuration.StudentID;
      this.GrievancessubmissionData.RequesterID=this.RequesterID;
      this.GrievancessubmissionData.UpdatedLoginID = this.configuration.UpdatedLoginID;
      this.GrievancessubmissionData.AcademicInstanceID = this.configuration.AcademicInstanceID;
      this.GrievancessubmissionData.ExamInstanceID = this.configuration.ExamInstanceID; 
      this.GrievancessubmissionData.GrievanceRequestID   = this.GrievancessubmissionData.GrievanceRequestID  ;
    
      this.GrievancessubmissionService.PostDeleteGrievanceRequest(this.GrievancessubmissionData)
       .subscribe(value => {
        this.helperService.showSuccessMessage("Deleted Successfully.");  
        this.DeleteBtnDisabled = true;
        this.clearForm() ; 
       },
        err => {
          this.errorMessage=this.helperService.getErrorMessage(err);
          this.helperService.showSuccessMessage("Not Deleted.");    
        },
        () => { 
        });  
    }
  }

  
	EditClicked(e) {  debugger
    this.GrievancessubmissionData.GrievanceRequestID =  e.data.GrievanceRequestID;
    this.GrievancessubmissionData.StudentID =  this.configuration.StudentID             ;
    this.GrievancessubmissionData.GrievanceTypeID =  e.data.GrievanceTypeID            ;
    this.GrievancessubmissionData.Description =  e.data.Description     ; 
    this.GrievancessubmissionData.GrievanceDate =  e.data.GrievanceDate     ; 
    this.GrievancessubmissionData.GrievanceDocument     =  e.data.GrievanceDocument     ; 
    this.GrievancessubmissionData.GrievanceDocumentPath =  e.data.GrievanceDocumentPath     ; 
    this.GrievanceDocumentPath =   e.data.GrievanceDocumentPath    ; 
    if(e.data.GrievanceDocument !="" && e.data.GrievanceDocument != undefined){
      this.GrievanceDocumentExists =   true  ; 
    }
    else{
      this.GrievanceDocumentExists =   false  ; 
    }
    if( e.data.GrievanceRequestID > 0)
      {             
        this.DeleteBtnDisabled = false;
      }
      else
      {             
        this.DeleteBtnDisabled = true;
      }
    }
    
  getdata() {  
  }

  selectFile(event) {debugger
    debugger 
    this.selectedFiles = event.target.files;
    this.currentFile = this.selectedFiles.item(0);
  } 
  downloadMyFile(){
      const link = document.createElement(this.GrievancessubmissionData.GrievanceDocumentPath);
      link.setAttribute('target', '_blank');
      link.setAttribute('href', 'abc.net/files/test.ino');
      link.setAttribute('download', `products.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
  }
}

